import React, {useEffect, useState} from "react";
import MangeDashboard from "./MangeDashboard";
import axios from "axios";
import {useMediaQuery} from "beautiful-react-hooks";
import { toast } from "react-toastify";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { MdContentCopy } from "react-icons/md";
import moment from "jalali-moment";

    const PersionNameCoin = {
        "USDT" : "تتر",
        "BTC" : "بیت کوین",
        "ETH" : "اتریوم",
        "BNB" : "بایننس کوین",
        "SOL" : "سولانا",
        "XRP" : "ایکس آرپی",
        "ADA" : "کاردانو",
        "MANA": "مانا"
    }



    const persion = {
        'success':'موفق',
        'failure':'ناموفق',
        'processing': ' در حال انجام',
         'waiting':'در انتظار',
        'reject':'رد شد',
    }



export default function HistBardashtCoins () {


        const [isLoading,setIsLoading] = useState(true)
        const [bardashtList,setBardashtList] = useState([])
         let phone = sessionStorage.getItem('user')
        const isSmall = useMediaQuery('(max-width: 768px)')
        const [isCopied, setIsCopied] = useState(false);

        const onCopyText = () => {
            setIsCopied(true);
            toast.dismiss()
            
            toast.warning(' کپی شد!', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
    };




    useEffect(()=>{
        axios.get('https://api.sinatether.com/Auth/GetHisBardashtCoins',{
            params:{
                "phone":phone
            },
            withCredentials:true
        }).then((res)=>{
            if (res.status == 200){
                setBardashtList(res.data['bardasht_list'])
                setIsLoading(false)
            }
        }).catch((error)=>{
            if (error){
                setIsLoading(false)
                if (error.response.status === 400){
                    toast.dismiss()
                    toast.error("نشست شما منقضی شده است مجددا وارد شوید")
                }
            }
        })
    },[])




    return(

        <MangeDashboard>
        <div className={'list-report'}>
    <div className={''}>
            <div className={'plr-12'}>

            <div className={'head_29540 padd-title text-center'}>
                <div className="text-title-report">
                    تاریخچه برداشت های ارزی

                </div>

            </div>


                {isSmall ?
                    <div className={'listContent__29514'}>
                        <div className="tableHeader__29540 bt-0">
                        <div className={'col-3 text-normal pl-0'}>تاریخ</div>

                            <div className={'col-3 text-normal pl-0 '}> نام ارز</div>
                            <div className={'col-3 text-normal pl-0 '}>مقدار</div>

                            <div className={'col-3 text-normal pl-0 '}>وضعیت</div>



                        </div>
                        {isLoading ?
                            <div className={'text-center mt-5 pt-5 mb-5 pt-5'}>

                                <i className="fa fa-spinner fa-spin loadIcon"></i>


                            </div>
                            :


                            <div className={'listcoinTable '}>
                                {bardashtList ? bardashtList.map((list) => (
                                    <>


                                    
<div className= {`accordion-item  `}>
<h2 className="accordion-header danger-box " id={`heading${list['id']}`}>
    <button className={`accordion-button   pt-0 pb-0 collapsed pr-12  `} type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapse${list['id']}`}
            aria-expanded="true"
            aria-controls={`collapse${list['id']}`}>



<div className={'row itemCoins titem2020 w-100 '} name={'n'}
                                        >


                                            
                                                            <div className={'col-3 pl-0'}>

                                                            {list['date_accepted'] ? 
                                                    <span className={'mynumber text-content mynorm-text   text-right d-grid'}>
                                                        <span className="mynumber text-content mynorm-text   text-right d-grid">{moment(list['date_accepted'].split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}</span>

                                                        {list['date_accepted'].split('T')[1].split('.')[0] ?
                                                             <span className="mynumber text-content text-content" >
                                                                 {list['date_accepted'].split('T')[1].split('.')[0]}

                                                            </span>

                                                            :
                                                            <span className="mynumber text-content mynorm-text   text-right d-grid" >
                                                                 {list['date_accepted'].split('T')[1]}

                                                            </span>
                                                            

                                                           }
                                                        
                                                        </span>


                                                            :

                                                            <span className={'mynumber text-content mynorm-text   text-right d-grid'}>
                                                            <span className="mynumber text-content mynorm-text   text-right d-grid">{moment(list['date'].split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}</span>
    
                                                            {list['date'].split('T')[1].split('.')[0] ?
                                                                 <span className="mynumber text-content mynorm-text   text-right d-grid" >
                                                                     {list['date'].split('T')[1].split('.')[0]}
    
                                                                </span>
    
                                                                :
                                                                <span className="mynumber text-content mynorm-text   text-right d-grid" >
                                                                     {list['date'].split('T')[1]}
    
                                                                </span>
                                                                
    
                                                               }
                                                            
                                                            </span>

                                            }


                                                            </div>

                                            <div className={'col-3 pl-0 pr-0 '}>

                                            <span
                                                className={'text-normal'}>

                                                

                                                <span className={'pl-1 text-normal text-content lineheight-40'}>
                                                         {list['currency']}
                                               </span>

                                            </span>


                                            </div>
                                            <div className={'col-3  pl-0 '}>
                                            <span className={'text-normal text-content lineheight-40 '}>
                                                {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(list['amount'])}
                                            </span>
                                            </div>

                                         
                                            <div className={'col-3 pl-0 '}>
                                            {list['state'] == 'success' ? 

                                            <span className={'text-normal text-success lineheight-40 '}>


                                                
                                                
                                                
                                                
                                                {persion[list['state']]}
                                            </span>

                                            :

                                            <span className={'text-normal text-danger lineheight-40 '}>


                                                
                                                
                                                
                                                
                                            {persion[list['state']]}
                                        </span>

}



                                            </div>



                                        </div>
  


    </button>
</h2>
<div id={`collapse${list['id']}`}
     className="accordion-collapse collapse "
     aria-labelledby={`heading${list['id']}`}
     data-bs-parent="#accordionExample">
    <div className="accordion-body kfjhsygbehbrhegrter padding-0 bg-white borderwhiteshbdhbsd">

        <div className="djsdhfyytrgsgfvsaacc ksdjifshduisbd2533535">


            
        <div className={'row pb-2'}>
                                                <div className={'col-2'}>
                                                    <span className={'text-normal '}>آدرس:</span>
                                                </div>
                                                <div className={'col-5'}>
                                                    <span className={'text-normal text-content'}>{list['address']}</span>

                                                </div>

                                        </div>

          
        <div className={'row pb-2'}>
                                               <div className={'col-6'}>


                                                
                                               <div className="row">

<div className={'col-2'}>
         <span className={'text-normal '}>شبکه:</span>
</div>
<div className={'col-3 pr-0 pl-3 '}>
<span className={'text-normal text-content '}>
{list['chain']}
</span>
</div>
    
</div>

                                               
                                              


                                               </div>

                                               <div className="col-6">


                                               <div className="row">
                                                <div className={'col-2'}>
                                                         <span className={'text-normal text-content'}>تگ</span>
                                                </div>
                                                <div className={'col-5'}>
                                                    <span className={'text-normal text-content '}>{list['memo']}</span>

                                                </div>
                                                </div>
                                          




                                            

</div>

                                        </div>



                                        <div className="row">


                                            
                                        {list['state'] == 'success'?

                                        
                                        
<div className={' row'}>
    <div className={'text-normal col-4'}>
        کدتراکنش (txId):
    </div>
   {list['txID'] ?
    <div className={'text-normal text-content col-8'}>

              <span className={'text-normal text-content  mytext-warning pl-2 '}>
                ....{list['txID'].slice(0,20)}
                    <CopyToClipboard text={list['txID']}
                                           onCopy={onCopyText}>
                              <span className={'text-normal text-content'}>
                                  <MdContentCopy/></span>
                          </CopyToClipboard>
                </span>
    </div>
    :


    <div className={'text-large mytext-warning col-10'}>
        در انتظار دریافت...
     </div>
      



        }
</div>

:

<></>
    }

                                        </div>


 
                              

                                




    </div>




    </div>
</div>
</div>



                                        


                          





                                        </>


                                    ))

                                    :

                                    <div className={'text-center mt-5 pt-5 mb-5 pt-5'}>
                                        <span className={'text-muted'}>هیچ برداشتی ثبت نشده</span>

                                    </div>


                                }


                            </div>
                        }


                    </div>
                    :
                    <div className={'listContent__29514'}>
                        <div className="tableHeader__29540 bt-0">
                            <div className={'col-2 text-normal '}>تاریخ</div>
                            <div className={'col-1 text-normal '}> نام ارز</div>
                            <div className={'col-2 text-normal '}>مقدار</div>
                            <div className={'col-3 text-normal '}>آدرس</div>
                            <div className={'col-1 text-normal '}>تگ</div>
                            <div className={'col-1 text-normal '}>شبکه</div>
                            <div className={'col-2 text-normal '}>وضعیت</div>



                        </div>
                        {isLoading ?
                            <div className={'text-center mt-5 pt-5 mb-5 pt-5'}>

                                <i className="fa fa-spinner fa-spin loadIcon"></i>


                            </div>
                            :


                            <div className={'listcoinTable '}>



                                {bardashtList ? bardashtList.map((list) => (

                                        <div className="accordion-item">
                                        <h2 className="accordion-header " id={`heading${list['id']}`}>
                                            <button className="accordion-button pt-0 pb-0  collapsed" type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse${list['id']}`}
                                                    aria-expanded="false"
                                                    aria-controls={`collapse${list['id']}`}>


                                                <div className={'row itemCoins w-100 titem2020 '}>


                                                <div className={'col-2 text-right'}>
                                                {list['date_accepted'] ? 

                                                            <span
                                                                className={'mynumber text-content mynorm-text pr-1 lineheight-40'}>
                                                                                <span className="mynumber text-content mynorm-text  lineheight-40  ">{moment(list['date_accepted'].split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}</span>

                                                                                {list['date_accepted'].split('T')[1].split('.')[0] ?
                                                                                        <span className="pr-1 mynumber text-content mynorm-text  lineheight-40" >
                                                                                            {list['date_accepted'].split('T')[1].split('.')[0]}

                                                                                        </span>

                                                                                        :
                                                                                        <span className="pr-1 mynumber text-content mynorm-text  lineheight-40" >
                                                                                            {list['date_accepted'].split('T')[1]}

                                                                                        </span>
                                                            

                                                                                         }
                                                                                                                          
                                                                    </span>

                                                        :
                                                        <span
                                                        className={'mynumber text-content mynorm-text pr-1 lineheight-40  '}>
                                                                        <span className="mynumber text-content mynorm-text lineheight-40   ">{moment(list['date'].split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}</span>

                                                                        {list['date'].split('T')[1].split('.')[0] ?
                                                                                <span className="pr-1 mynumber text-content mynorm-text  lineheight-40" >
                                                                                    {list['date'].split('T')[1].split('.')[0]}

                                                                                </span>

                                                                                :
                                                                                <span className="pr-1 mynumber text-content mynorm-text lineheight-40  " >
                                                                                    {list['date'].split('T')[1]}

                                                                                </span>
                                                    

                                                                                 }
                                                                                                                  
                                                            </span>
                                  }


                                            </div>
                                            <div className={'col-1  text-right'}>

                                            <span
                                                className={'text-normal text-content lineheight-40  '}>{list['currency']}</span>


                                            </div>
                                            <div className={'col-2  text-right '}>
                                            <span className={'text-normal text-content lineheight-40   '}>
                                                {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(list['amount'])}
                                            </span>
                                            </div>
                                            <div className={'col-3 pr-0 pl-0 text-right '}>
                                            <span className={'text-normal text-content lineheight-40  '}>
                                                {list['address']}
                                            </span>
                                            </div>
                                            <div className={'col-1 pr-0 pl-0 text-center'}>
                                            <span className={'text-normal text-content lineheight-40  '}>
                                                {list['memo']}
                                            </span>
                                            </div>
                                            <div className={'col-1 pr-0 pl-0  text-center'}>
                                            <span className={'text-normal text-content lineheight-40  '}>
                                                {list['chain']}
                                            </span>
                                            </div>
                                                    <div className={'col-2  text-right '}>



                                                    {list['state'] == 'success' ? 

<span className={'text-normal text-success lineheight-40 '}>


    
    
    
    
    {persion[list['state']]}
</span>

:

<span className={'text-normal text-danger lineheight-40 '}>


    
    
    
    
{persion[list['state']]}
</span>

}
                                           
                                            </div>











                                                <div
                                                    className="col-5 pointer text-right text-blue-primery text-large priceTt"
                                                > <span
                                                    className={'text-large priceTt'}></span></div>



                                                </div>




                                            </button>
                                        </h2>
                                        <div id={`collapse${list['id']}`}
                                             className="accordion-collapse collapse "
                                             aria-labelledby={`heading${list['id']}`}
                                             data-bs-parent="#accordionExample">
                                            <div className="accordion-body kfjhsygbehbrhegrter padding-0 bg-white borderwhiteshbdhbsd">


                                            <div className="djsdhfyytrgsgfvsaacc ksdjifshduisbd2533535">


                                            {list['state'] == 'success' ? 

                                                <div className={'text-center'}>

                                                    <span>
                                                        <span className={' text-dark text-large pr-2'}>
                                                            کدتراکنش(txId):
                                                        </span>
                                                        {list['txID'] ?
                                                        <span className={'text-large  mytext-warning pr-2 '}>
                                                        ....{list['txID'].slice(0,35)}
                                                            <CopyToClipboard text={list['txID']}
                                                                                   onCopy={onCopyText}>
                                                                      <span className={'text-large'}>
                                                                          <MdContentCopy/></span>
                                                                  </CopyToClipboard>
                                                        </span>
                                                        :
                                                        <span className={'mytext-warning  pr-2'}>
                                                            درانتظار دریافت...
                                                         </span>                                                   
                                                          }

                                                    </span>

                                                </div>

                                                :
                                                <div className={'text-center'}>

                                                <span>


                                                    در انتظار دریافت کد تراکنش ......

                                                </span>

                                            </div>

                                             }

                                             </div>





                                            </div>
                                        </div>
                                    </div>

















                                    ))

                                    :

                                    <div className={'text-center mt-5 pt-5 mb-5 pt-5'}>
                                        <span className={'text-muted'}>هیچ برداشتی ثبت نشده</span>

                                    </div>


                                }
                                </div>


                        }


                    </div>

                }




        </div>


</div>
        </div>

    </MangeDashboard>


    )
}